import { useQueryClient } from '@tanstack/react-query';
import { FlaskConical, Loader2 } from 'lucide-react';
import { useState } from 'react';
import { useApi } from '../api/client.js';

// Dev-only shortcut to fire a synthetic duress alarm so the UI can be exercised without
// a mobile client in the loop. Only rendered when `import.meta.env.DEV` is truthy —
// Vite's production build inlines that as `false` and tree-shakes the button out.
export function TestAlarmButton() {
  const api = useApi();
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  if (!import.meta.env.DEV) return null;

  async function trigger() {
    setBusy(true);
    setErr(null);
    try {
      await api('/alarms', {
        method: 'POST',
        body: JSON.stringify({
          type: 'duress',
          triggered_at: new Date().toISOString(),
          device_battery: Math.floor(Math.random() * 60) + 20,
          location: {
            lat: -33.8688 + (Math.random() - 0.5) * 0.05,
            lng: 151.2093 + (Math.random() - 0.5) * 0.05,
            accuracy_m: 10 + Math.random() * 20,
          },
          metadata: { trigger_method: 'dev_button' },
        }),
      });
      qc.invalidateQueries({ queryKey: ['alarms'] });
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex flex-col items-end">
      <button
        type="button"
        onClick={trigger}
        disabled={busy}
        title="Create a synthetic duress alarm (dev only)"
        className="inline-flex items-center gap-1.5 rounded-md border border-dashed border-amber-400 bg-amber-50 px-3 py-1 text-xs font-medium text-amber-800 transition hover:bg-amber-100 disabled:opacity-50"
      >
        {busy ? (
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
        ) : (
          <FlaskConical className="h-3.5 w-3.5" />
        )}
        Trigger test alarm
      </button>
      {err && <span className="mt-1 text-xs text-red-600">{err}</span>}
    </div>
  );
}
